/**
 * @author Fernando Ruano
 * @file actions.js
 * @description User Actions
 */

// Constants
import {
  GET_ALL_USERS,
  CREATE_USER,
  UPDATE_USER,
  GET_USER_BY_ID,
  DELETE_USER_BY_ID,
  SET_USER_INFO,
  GET_USER_LOGIN_INFO,
  GET_USER_BY_USERNAME,
  GET_VALIDATE_PERMISSION,
  GET_USER_BY_EMAIL,
  GET_USER_DATA_REGISTER
} from './constants';

/**
 * Call process to get user info after login
 * @param  { object } data - Username or identification
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_USER_LOGIN_INFO
 */
export const getUserLoginInfo = (data, callback) => ({
  type: GET_USER_LOGIN_INFO,
  payload: { data },
  callback
});

/**
 * Call process to get user info after login on auth validation (registration steps)
 * @param  { object } data - Username or identification
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_USER_LOGIN_INFO
 */
export const getUserDataRegister = (data, callback) => ({
  type: GET_USER_DATA_REGISTER,
  payload: { data },
  callback
});

/**
 * Call process to get user permission by module
 * @param  { object } data - Username or identification
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_VALIDATE_PERMISSION
 */
export const getValidatePermission = (data, callback) => ({
  type: GET_VALIDATE_PERMISSION,
  payload: { data },
  callback
});

/**
 * Call process to set user info
 * @param  { object } data - User data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of LOG_IN
 */
export const setUserInfo = (data, callback) => ({
  type: SET_USER_INFO,
  payload: { data },
  callback
});

/**
 * Call process to get all users list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ALL_USERS
 */
export const getUsersArray = (data, callback) => ({
  type: GET_ALL_USERS,
  payload: { data },
  callback
});

/**
 * Call process to get user by id
 * @param  { object } data - User Id
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ROL_BY_ID
 */
export const getUserById = (data, callback) => ({
  type: GET_USER_BY_ID,
  payload: { data },
  callback
});

/**
 * Call process to get user by username
 * @param  { object } data - Username
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_USER_BY_USERNAME
 */
export const getUserByUserName = (data, callback) => ({
  type: GET_USER_BY_USERNAME,
  payload: { data },
  callback
});

/**
 * Call process to get user by email
 * @param  { object } data - Email
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_USER_BY_EMAIL
 */
export const getUserByEmail = (data, callback) => ({
  type: GET_USER_BY_EMAIL,
  payload: { data },
  callback
});

/**
 * Call process to create user
 * @param  { object } data - User Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of CREATE_USER
 */
export const createUser = (data, callback) => ({
  type: CREATE_USER,
  payload: { data },
  callback
});

/**
 * Call process to update user
 * @param  { object } data - User Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of UPDATE_USER
 */
export const updateUser = (data, callback) => ({
  type: UPDATE_USER,
  payload: { data },
  callback
});

/**
 * Call process to delete user
 * @param  { object } data - User Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of DELETE_USER_BY_ID
 */
export const deleteUserById = (data, callback) => ({
  type: DELETE_USER_BY_ID,
  payload: { data },
  callback
});
